$(document).ready(function () {
    $('.proffesional-item').hover(
        function () {
            $('.main-page').addClass('hovered'); // Добавление класса при наведении
        },
        function () {
            $('.main-page').removeClass('hovered'); // Удаление класса при уходе с блока
        });
    $('.cosmetics-item').hover(
        function () {
            $('.sec1').addClass('hovered'); // Добавление класса при наведении
            $('.main-page').addClass('hovered-lang');
        },
        function () {
            $('.sec1').removeClass('hovered'); // Удаление класса при уходе с блока
            $('.main-page').removeClass('hovered-lang');
        });
});

function showLanguages() {
    $(".dropdown-language").toggleClass("show");
}

window.onclick = function (event) {
    if (!event.target.matches('.lang-drpdwn-btn')) {
        var dropdowns = $(".dropdown-language");
        for (let i = 0; i < dropdowns.length; i++) {
            var openDropdown = dropdowns[i];
            if (openDropdown.classList.contains('show')) {
                openDropdown.classList.remove('show');
            }
        }
    }
}
// 
// 
function initializeSwiper() {
    // Получаем ширину экрана
    var screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    // Проверяем, если ширина экрана 768 пикселей или меньше
    if (screenWidth <= 768) {
        // Инициализируем слайдер
        var swiper = new Swiper(".mySwiper", {
            slidesPerView: 2,
            centeredSlides: true,
            loop: true,
            spaceBetween: 20,
            // initialSlide: 1,
            pagination: {
                el: ".swiper-pagination",
                type: "fraction",
            },
            navigation: {
                nextEl: ".swiper-next",
                prevEl: ".swiper-prev",
            },
            breakpoints: {
                // when window width is >= 320px
                320: {
                    slidesPerView: 1,
                },
                // when window width is >= 480px
                575: {
                    slidesPerView: 1,
                }
            }
        });
    }

    var swiper = new Swiper(".coursesSwiper", {
        slidesPerView: 2,
        centeredSlides: true,
        loop: true,
        spaceBetween: 20,
        // initialSlide: 1,
        pagination: {
            el: ".swiper-pagination",
            type: "fraction",
        },
        navigation: {
            nextEl: ".swiper-next",
            prevEl: ".swiper-prev",
        },
        breakpoints: {
            // when window width is >= 320px
            320: {
                centeredSlides: false,
                slidesPerView: 'auto'
            },
            // when window width is >= 769px
            769: {
                slidesPerView: 3,
            }
        }
    });
}

// Вызываем функцию при загрузке страницы
window.addEventListener('load', initializeSwiper);

// Вызываем функцию при изменении размера окна
window.addEventListener('resize', initializeSwiper);
// 
// 
var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function () {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
            panel.classList.remove('active');
        } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
            panel.classList.add('active');
        }
    });
}
// 
// 

// 
// 
$('.search-btn').click(function () {
    $('.search-item').toggleClass('active');
    $('.search-overlay').toggleClass('active');
    // if ($(window).width() < 575) {
    //     $('#burger-menu-close').click();
    // }
})
// 
// 
$(document).ready(function () {
    // Функция для проверки столкновения
    function isElementInViewport(el) {
        var rect = el.getBoundingClientRect();
        return (
            rect.top <= 0 &&
            rect.bottom >= 0
        );
    }

    // Обработчик события скролла
    $(window).scroll(function () {
        // Получите элемент, с которым вы хотите проверить столкновение
        var block = $(".sticky-header")[0];

        // Проверьте столкновение
        if (isElementInViewport(block)) {
            $(block).addClass('scrolled');
            $('.sticky-header-nav').addClass('scrolled');
        } else {
            $(block).removeClass('scrolled');
            $('.sticky-header-nav').removeClass('scrolled');
        }
    });
});
// 
// 
function showLanguages(dropdownId) {
    $("#" + dropdownId).toggleClass("show");
}

$(document).click(function (event) {
    if (!$(event.target).hasClass('lang-drpdwn-btn')) {
        var dropdowns = $(".dropdown-language");
        for (let i = 0; i < dropdowns.length; i++) {
            var openDropdown = dropdowns[i];
            if ($(openDropdown).hasClass('show')) {
                $(openDropdown).removeClass('show');
            }
        }
    }
});
// 
// 
$(document).ready(function () {
    $('.proffesional-item').hover(
        function () {
            $('.main-page').addClass('hovered'); // Добавление класса при наведении
        },
        function () {
            $('.main-page').removeClass('hovered'); // Удаление класса при уходе с блока
        });
    $('.cosmetics-item').hover(
        function () {
            $('.sec1').addClass('hovered'); // Добавление класса при наведении
            $('.main-page').addClass('hovered-lang');
        },
        function () {
            $('.sec1').removeClass('hovered'); // Удаление класса при уходе с блока
            $('.main-page').removeClass('hovered-lang');
        });
});

formatMoney = function(cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal   = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) { return 0; }

        number = (number/100.0).toFixed(precision);

        var parts   = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents   = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
};

function currencyFormSubmit(event) {
    event.target.form.submit();
  }

  document.querySelectorAll('.shopify-currency-form select').forEach(function(element) {
    element.addEventListener('change', currencyFormSubmit);
  });

 //
 var acc = document.getElementsByClassName("accordeon-item");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
      panel.classList.remove('active');
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
      panel.classList.add('active');
    } 
  });
}